import { useSortable } from "@dnd-kit/sortable";
import { useState } from "react";
import { Etapa as EtapaEdicao } from "shared/features/api/edicao/edicaoSlice";
import { CSS } from "@dnd-kit/utilities";
import {IconButton, TableCell, TableRow, TextField } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface SortableTableRowProps {
  row: EtapaEdicao;
  onUpdateWeight: (id: string, newWeight: number) => void;
  onDelete: (id: string) => void;
}

export const SortableTableRow: React.FC<SortableTableRowProps> = ({ row, onUpdateWeight, onDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: row.idEtapa });

  const [isEditing, setIsEditing] = useState(false);
  const [localWeight, setLocalWeight] = useState(row.peso);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : "auto",
    boxShadow: isDragging ? "0px 4px 20px rgba(0, 0, 0, 0.1)" : "none",
    backgroundColor: isDragging ? "#f0f0f0" : "white",
  };

  const handleConfirm = () => {
    onUpdateWeight(row.idEtapa.toString(), localWeight);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setLocalWeight(row.peso);
    setIsEditing(false);
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      {...attributes}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row" sx={{ width: "50px" }}>
        <IconButton {...listeners} sx={{ cursor: "grab" }}>
          <DragIndicatorIcon />
        </IconButton>
      </TableCell>
      <TableCell>{row.ordem}°</TableCell>
      <TableCell>{row.nome}</TableCell>
      <TableCell>
        {isEditing ? (
          <TextField
            type="number"
            size="small"
            value={localWeight}
            onChange={(e) => setLocalWeight(Number(e.target.value))}
          />
        ) : (
          row.peso
        )}
      </TableCell>
      <TableCell align="right">
        {isEditing ? (
          <>
            <IconButton onClick={handleConfirm} aria-label="confirmar">
              <CheckIcon />
            </IconButton>
            <IconButton onClick={handleCancel} aria-label="cancelar">
              <CloseIcon />
            </IconButton>
          </>
        ) : (
          <>
            <IconButton onClick={() => setIsEditing(true)} aria-label="editar">
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => onDelete(row.idEtapa.toString())} aria-label="deletar">
              <DeleteIcon />
            </IconButton>
          </>
        )}
      </TableCell>
    </TableRow>
  );
};